import { useState } from "react";

import { cn } from "../../lib/cn";

interface CardImageProps {
  readonly src: string | null;
  readonly alt?: string;
  readonly className?: string;
}

/** A card picture, or a neat "No picture" box when there is none or it fails to load. */
export function CardImage({ src, alt = "", className }: CardImageProps) {
  const [failed, setFailed] = useState(false);
  if (src === null || failed) {
    return (
      <div
        className={cn(
          "flex aspect-[5/7] w-full items-center justify-center rounded bg-muted text-xs text-muted-foreground",
          className,
        )}
      >
        No picture
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={cn("aspect-[5/7] w-full rounded object-contain", className)}
    />
  );
}
